import React, { useState, useRef } from 'react'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import Icon from 'meinian-package/src/component/icon'
import { getSampleStatusLabel, getSampleStatusList, getSampleStatusValue } from 'component/waterfall.card/sampleCardExamine/common'
import EditSample from 'component/editSample'
import classNames from 'classnames'
import RelatedPersonnel from './relatedPersonnel'
import Dynamic from './dynamic'
import BaseInfo from './baseInfo'
import Footer from './footer'
import styles from './index.module.less'

export default ({ currentImage, onInit, setIsAnnotate, onChange, setBanOperation }:any) => {
  const { process, processId, stepStatus, stepId, state } = currentImage
  const stepsList = getSampleStatusList({ process: [process] })
  const processMenu = (<div className={styles['mn-process-menu']}>
    {
      stepsList[0]?.children?.map(item => <div
        className={classNames(styles['mn-process-menu-item'], { [styles['mn-process-menu-item-active']]: getSampleStatusValue({ processId, stepStatus, stepId }) === item.value })}
      >
        <div className={styles['mn-process-menu-item-point']} style={{ visibility: getSampleStatusValue({ processId, stepStatus, stepId }) === item.value ? 'visible' : 'hidden' }} />
        {item.name}
      </div>)
    }
  </div>)
  const [propIndex, setPropIndex] = useState(0)
  const [visible, setVisible] = useState(false)
  const [nameVisible, setNameVisible] = useState(false)

  const dynamicRef = useRef(null)

  return <>
    <div className={styles.mnImageDetailInfoViewContent}>
      <div className={styles.sampleState}>
        <div className={styles.sampleStateTitle}>样衣状态</div>
        <Dropdown
          trigger="click"
          open={nameVisible}
          onOpenChange={vis => setNameVisible(vis)}
          overlay={processMenu}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <div className={styles.sampleStateName}>
            {getSampleStatusLabel({ process, processId, stepStatus, stepId, state })}
            <Icon
              type="m-Vxing_xia"
              style={{
                fontSize: '16px',
                transform: nameVisible ? 'rotate(180deg)' : undefined,
                transition: 'all 0.3s'
              }}
            />
          </div>
        </Dropdown>
      </div>
      <RelatedPersonnel
        currentImage={currentImage}
        onPropIndex={(val) => setPropIndex(val)}
        onVisibleChange={val => {
          setVisible(val)
          setBanOperation(true)
        }}
      />
      <Dynamic currentImage={currentImage} ref={dynamicRef} />
      <BaseInfo
        currentImage={currentImage}
        onPropIndex={(val) => setPropIndex(val)}
        onVisibleChange={val => {
          setVisible(val)
          setBanOperation(true)
        }}
      />
    </div>
    <Footer
      onChange={onChange}
      setIsAnnotate={setIsAnnotate}
      onInit={() => {
        dynamicRef.current?.onInit()
        onInit()
      }}
      onPropIndex={(val) => setPropIndex(val)}
      currentImage={currentImage}
      onVisibleChange={val => {
        setVisible(val)
        setBanOperation(true)
      }}
    />
    {visible ? <EditSample
      visible={visible}
      data={currentImage}
      setVisible={(val) => {
        setVisible(val)
        setBanOperation(val)
      }}
      propIndex={propIndex}
      onChange={(success, newItemData) => {
        onChange?.(success, newItemData)
        dynamicRef.current?.onInit()
        onInit()
      }}
    /> : null}
  </>
}
